import { Component, Inject, NgModule } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { combineLatest, of, map, tap } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CatalogMaintenanceResponse } from '@uw/core/api/models';
import { CatalogMaintenanceService } from '@uw/core/services/catalog-maintenance.service';


@Component({
    selector: 'uw-edit-catalog-maintenance-dialog',
    templateUrl: './edit-catalog-maintenance-dialog.component.html',
    styleUrls: ['./edit-catalog-maintenance-dialog.component.scss'],
    imports: [A11yModule, MatIconButton, MatDialogClose, MatIcon, ReactiveFormsModule, TranslateModule]
})
export class EditCatalogMaintenanceDialogComponent {
  readonly form: UntypedFormGroup = new UntypedFormGroup({
    recordId: new UntypedFormControl(null, []),
    prov: new UntypedFormControl(null, [Validators.required]),
    city: new UntypedFormControl(null, [Validators.required]),
    suWay: new UntypedFormControl(null, [Validators.required]),
    drCode: new UntypedFormControl(null, [])
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) _catalogMaintenance: CatalogMaintenanceResponse,
    private readonly _dialogRef: MatDialogRef<EditCatalogMaintenanceDialogComponent>,
    private readonly _catalogMaintenanceService: CatalogMaintenanceService
  ) {
    if (_catalogMaintenance) {
      this.form.patchValue(_catalogMaintenance, { emitEvent: false });
    }
  }

  handleSave(catalogMaintenance: any) {
    const obs$ = catalogMaintenance.recordId ? this._catalogMaintenanceService.update(catalogMaintenance) : this._catalogMaintenanceService.create(catalogMaintenance);

    obs$.pipe(
      tap(_ => this._dialogRef.close(catalogMaintenance))
    ).subscribe();
  }
}

@NgModule({
    exports: [
        EditCatalogMaintenanceDialogComponent
    ],
    imports: [
        A11yModule,
        CommonModule,
        TranslateModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        ReactiveFormsModule,
        EditCatalogMaintenanceDialogComponent
    ]
})
export class EditCatalogMaintenanceDialogModule { }
